import { render } from "./ConfirmIdentity.vue?vue&type=template&id=656a08d7"
import script from "./ConfirmIdentity.vue?vue&type=script&lang=js"
export * from "./ConfirmIdentity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__